var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('connection-step',{attrs:{"model":_vm.model,"schema-fetching-allowed":false}}),_vm._v(" "),_c('multiple-mapping-step',{attrs:{"model":_vm.model}}),_vm._v(" "),_c('events-step',{attrs:{"model":_vm.model}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-068e6970","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/integrations/types/salesforce/SalesforceSettings.vue
// module id = null
// module chunks = 